export default __webpack_public_path__ + "static/dwarves-38bc4ebe0ac0a56d925278f8c797fbb5.webp";